export const women_articles = [
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/17/is-a-columbia-four-peat-possible-what-to-expect-this-ivy-league-womens-basketball-season/",
        article_title: "Is a Columbia four-peat possible? What to expect this Ivy League women’s basketball season",
        article_authors: "Jillian Prunty & Nicholas Fink",
        image_url: "https://www.columbiaspectator.com/resizer/v2/4OCFHKJVSRCXPJPMGHMUHPHX6E.JPG?auth=3ce58bae10c5adfb972bcc67b3f66cec515589764c4329dc4b1aa9b30c00201f"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/20/cubs-on-the-prowl-a-look-at-womens-basketballs-newcomers/",
        article_title: "Cubs on the prowl: A look at women’s basketball’s newcomers",
        article_authors: "Arielle Rieder",
        image_url: "https://www.columbiaspectator.com/resizer/v2/NAPFMGXMHVABFP62CKOB2MPFOY.png?auth=b5ffd64a972878c53a4a7b45aadf7718c93e08368af05642a650f42a80c03a80"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/19/from-the-barnard-bears-to-the-big-dance-tracing-the-evolution-of-womens-basketball-at-columbia/",
        article_title: "From the Barnard Bears to the Big Dance: Tracing the evolution of women’s basketball at Columbia",
        article_authors: "Jillian Prunty",
        image_url: "https://www.columbiaspectator.com/resizer/v2/XZYHSWT5SJEDLLGCI3Y2DULROI.png?auth=a54a047739545137b0f3c508cea5fcb7becbca0c972695b5e8327c6d2186f143"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/19/we-show-up-for-our-players-womens-basketballs-new-assistant-coach-kizmahr-grell-on-team-sisterhood-and-consistency/",
        article_title: "‘We show up for our players’: Women’s basketball’s new assistant coach Kizmahr Grell on team sisterhood and consistency",
        article_authors: "Robby Swan",
        image_url: "https://www.columbiaspectator.com/resizer/v2/B7HJTHQNVBDOBGZRK6HEGEE44A.jpg?auth=e6c922ae1dade2c57b6a042d921ad0b1245a134b497fb857232ca044273218f7"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/03/ominous-opening-cornell-upsets-womens-basketball-67-60/",
        article_title: "Ominous opening: Cornell upsets women’s basketball 67-60",
        article_authors: "Nicholas Fink",
        image_url: "https://www.columbiaspectator.com/resizer/v2/YPZN3M2WZZBZLCGCUHLZQ6WJQY.jpg?auth=ff9535c61e950aecc9f62b073d6656bfd3d0d6386edc3b06abd55aa626fe4439"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/10/womens-basketball-narrowly-defeats-harvard-for-first-ivy-win/",
        article_title: "Women’s basketball narrowly defeats Harvard for first Ivy win",
        article_authors: "Jillian Prunty",
        image_url: "https://www.columbiaspectator.com/resizer/v2/IUMS7NJUNNDWBP4FJHFLGDUL2Q.jpg?auth=ad59c8fd2a0dc0a58bf66ea5c1874808a44b0f953101f8f94ea5608874908e9f"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/17/highway-robbery-nasi-simmons-shuts-down-yale-in-womens-basketball-win/",
        article_title: "Highway robbery: Nasi Simmons shuts down Yale in women’s basketball win",
        article_authors: "Nicholas Fink",
        image_url: "https://www.columbiaspectator.com/resizer/v2/Z3VXIVTKTFFFRE27KHLLN32FWM.jpg?auth=776bcf49b19e59015531b52a017e2a6c0d40405995e3e6dda499c774f84468b7"
    },
    {
        article_link: "https://www.columbiaspectator.com/sports/2026/01/19/womens-basketball-beats-brown-improves-to-3-1-in-conference-play/",
        article_title: "Women’s basketball beats Brown, improves to 3-1 in conference play",
        article_authors: "Jillian Prunty",
        image_url: "https://www.columbiaspectator.com/resizer/v2/BNI5CUVD4NCBXKWHOUD4XTCMRE.jpg?auth=ed55e1ff50640e9bc4a610c4b3c5301787d11aa361c0a32d1804ee0c198e354c"
    }
];
